import { Button, Icon } from '@virtidev/toolbox';
import React, { useCallback, useState } from 'react';
import * as Styled from './MobileGoLandscapeFullscreenPrompt.styled';
import { useSelector, useDispatch } from 'react-redux';
import {
  isFullscreenSelector,
  setFullscreen,
} from '@vh/slices/vh-player/VHPlayerSlice';

const MobileGoLandscapeFullscreenPrompt = ({ fullscreenElementRef }) => {
  const [dismissed, setDismissed] = useState(false);
  const isFullscreen = useSelector(isFullscreenSelector);
  const dispatch = useDispatch();

  const handleGoFullscreen = useCallback(() => {
    dispatch(setFullscreen(true));
    // fullscreenElementRef.current.requestFullscreen()
  }, [dispatch]);

  const handleContinue = useCallback(() => {
    setDismissed(true);
  }, []);

  if (dismissed) {
    return <></>;
  }

  return (
    <Styled.MobileGoBigWrapper>
      <div>
        We recommend landscape and fullscreen mode for optimal experience on
        mobile devices.
      </div>
      <Styled.MessagesWrapper>
        <Styled.LandscapeWellDone>
          <Icon icon="success" type="outline" size="1.5rem" color="turquoise" />
          <div>
            You are using landscape mode. This is the best experience for mobile
            devices.
          </div>
        </Styled.LandscapeWellDone>
        <Styled.PortraitOhNo>
          <Icon icon="alert" type="outline" size="1.5rem" color="danger" />
          <div>
            You are using portrait mode. Please switch to landscape to continue.
          </div>
        </Styled.PortraitOhNo>
        {isFullscreen ? (
          <Styled.Message>
            <Icon
              icon="success"
              type="outline"
              size="1.5rem"
              color="turquoise"
            />
            <div>You are using fullscreen mode.</div>
          </Styled.Message>
        ) : (
          <div>
            <Button
              onClick={handleGoFullscreen}
              color={isFullscreen ? 'success' : 'turquoise'}
              icon="fullscreen"
            >
              Go fullscreen
            </Button>
          </div>
        )}
      </Styled.MessagesWrapper>
      <Styled.ContinueButton
        $isFullscreen={isFullscreen}
        color="turquoise"
        onClick={handleContinue}
      >
        Continue
      </Styled.ContinueButton>
    </Styled.MobileGoBigWrapper>
  );
};

export default MobileGoLandscapeFullscreenPrompt;
